import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';
import { getPreferredStorage } from './authStorage';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
    storage: {
      getItem: (key) => {
        try {
          const storageType = getPreferredStorage();
          const storage = storageType === 'localStorage' ? localStorage : sessionStorage;
          const item = storage.getItem(key);
          return item;
        } catch (error) {
          console.error('Error accessing storage:', error);
          return null;
        }
      },
      setItem: (key, value) => {
        try {
          const storageType = getPreferredStorage();
          const storage = storageType === 'localStorage' ? localStorage : sessionStorage;
          storage.setItem(key, value);
        } catch (error) {
          console.error('Error setting storage:', error);
        }
      },
      removeItem: (key) => {
        try {
          const storageType = getPreferredStorage();
          const storage = storageType === 'localStorage' ? localStorage : sessionStorage;
          storage.removeItem(key);
        } catch (error) {
          console.error('Error removing from storage:', error);
        }
      }
    }
  },
  global: {
    headers: {
      'X-Client-Info': 'supabase-js/2.39.7'
    }
  }
});